<template>
  <div class="site2026">
    <Site2026Header />
    <div class="nav-spacer" />
    <main>
      <router-view :key="$route.path" />
    </main>
    <Site2026Footer />
  </div>
</template>

<script>
import Site2026Header from '@/components/site2026/Header'
import Site2026Footer from '@/components/site2026/Footer'

export default {
  name: 'Site2026Layout',
  components: { Site2026Header, Site2026Footer },
  mounted() {
    this.ensureInter()
  },
  methods: {
    ensureInter() {
      if (document.getElementById('site2026-inter-font')) return
      const pre1 = document.createElement('link')
      pre1.rel = 'preconnect'
      pre1.href = 'https://fonts.googleapis.com'
      document.head.appendChild(pre1)
      const pre2 = document.createElement('link')
      pre2.rel = 'preconnect'
      pre2.href = 'https://fonts.gstatic.com'
      pre2.crossOrigin = 'anonymous'
      document.head.appendChild(pre2)
      const link = document.createElement('link')
      link.id = 'site2026-inter-font'
      link.rel = 'stylesheet'
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
      document.head.appendChild(link)
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/site2026/index.scss';
</style>
